export default __webpack_public_path__ + "dbae0ef5c50fc165ab653a0119eccd5e.png";